import React from 'react';

import { format } from 'date-fns';

import { OfferBadges } from 'components/offer-badges';
import BlockRenderer from 'components/sanity-block-renderer';
import { US_DATE_FORMAT } from 'utils/dateTime';
import { getConfigValue } from 'utils/environment';
import { getEndingDate } from 'utils/offers';

import { TimeLeftFlag } from './flags';
import {
  Body,
  Content,
  FlagsWrapper,
  Footer,
  HeaderContent,
  Heading,
  StyledPicture,
  TextWrapper,
  UpperTextOffer,
  Wrapper,
} from './styled';
import TicketPath from './ticket-path';
import { IOfferLayoutProps } from './types';

const OfferLayout: React.FC<IOfferLayoutProps> = ({
  className,
  offer,
  onClick,
  id,
  endingIn,
  platforms,
  displayLoginRequiredBadge,
}) => {
  const dateFormat = getConfigValue('dateFormat') || US_DATE_FORMAT;

  return (
    <Wrapper className={className} onClick={onClick}>
      <TicketPath id={id} />
      {offer?.localizedImage?.locale?.app && (
        <StyledPicture
          alt=""
          clipPathId={id}
          image={offer?.localizedImage?.locale?.app!}
          placeholderAspectRatio={664 / 288}
        >
          <Content>
            <TextWrapper>
              <UpperTextOffer>
                <FlagsWrapper>{endingIn && <TimeLeftFlag {...endingIn} />}</FlagsWrapper>
                <HeaderContent>
                  <Heading>
                    <BlockRenderer content={offer?.name?.localeRaw} />
                  </Heading>
                  <OfferBadges
                    platforms={platforms}
                    displayLoginRequiredBadge={displayLoginRequiredBadge}
                    endingIn={endingIn}
                  />
                </HeaderContent>
                <Body>
                  <BlockRenderer content={offer?.description?.localeRaw} />
                </Body>
              </UpperTextOffer>
              <Footer>{!!endingIn && format(getEndingDate(endingIn)!, dateFormat)}</Footer>
            </TextWrapper>
          </Content>
        </StyledPicture>
      )}
    </Wrapper>
  );
};

export default OfferLayout;
